/**
 * JSON utility module for geometry
 */
define("tmds/utils/geometryUtils", [
	"tmds/geometry/Point",
	"tmds/geometry/Line",
	"tmds/geometry/Polyline",
	"tmds/geometry/Extent",
	"tmds/validator"
], function(Point, Line, Polyline, Extent, validator) {
	"use strict";
	
	/**
	 * helper function to create geometry based on the input geometry in JSON format
	 * @return {tmds.geometry.Geometry}
	 */
	function fromJson(geomJson) {
		
		if (! validator.isDataObject(geomJson) || ! validator.isString(geomJson.type)) {
			
			throw new Error('Invalid Geometry Object - ' + geomJson + ' passed');
		}
		
		var geom;
		
		switch (geomJson.type) {
			case "Point":
				geom = new Point(geomJson);
				break;
			case "Line":
				geom = new Line(geomJson);
				break;
			case "Polyline":
				geom = new Polyline(geomJson);
				break;
			case "Extent":
				geom = new Extent(geomJson);
				break;
			default:
				geom = null;
				break;
		}
		
		if(geom == null)
			throw new Error('Invalid Geometry Object - ' + geomJson + ' passed');
		
		return geom;
	}
	
	return {
		'fromJson' : fromJson
	};
});